import { FormEventHandler, useState } from "react";
import Banner from "../components/Banner";
import NavbarIcons from "../components/NavbarIcons";
import NavbarMobile from "../components/NavbarMobile";
import NavbarTop from "../components/NavbarTop";
import NavbarUser from "../components/NavbarUser";
import { api } from "../utils/apiClient";
import { toast } from "react-toastify";
import Footer from "../components/Footer";

const AccountDeletion = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("Account Deletion Request");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const sendMessage: FormEventHandler = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      await api({
        method: "POST",
        url: "/api/message",
        data: { name, email, subject, text: message },
      });

      setLoading(false);
      toast.success("Request sent successfully.");
      setName("");
      setEmail("");
      setSubject("");
      setMessage("");
    } catch (error: any) {
      setLoading(false);
      toast.error("Unable to send message.");
    }
  };

  return (
    <div className="flq-navbar-icons-existence">
      <NavbarTop page="Account Deletion" />
      <Banner page="Request Account Deletion" />
      <div className="content-wrap">
        <div className="pt-6">
          <div className="container">
            <div className="row justify-content-center mb-6">
              <div
                className="col-12 col-lg-10 col-xl-8 flq-vertical-rhythm text-center"
                data-sr="team-text"
                data-sr-interval={100}
                data-sr-distance={10}
                data-sr-duration={1000}
              >
                <p
                  className="lead"
                  data-sr-item="team-text"
                  style={{
                    visibility: "visible",
                    opacity: 1,
                    transform:
                      "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)",
                    transition:
                      "opacity 1s cubic-bezier(0.5, 0, 0, 1) 0s, transform 1s cubic-bezier(0.5, 0, 0, 1) 0s",
                  }}
                >
                  If you would like to delete your account and associated data
                  from the <strong>TLP Mobile</strong> app, please complete the
                  form below. Our team at <strong>Arvotek Ltd</strong> will
                  process your request within 3-5 business days.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="pb-7">
          <div className="container-small">
            <div
              className="text-center mb-5"
              data-sr="contact-text"
              data-sr-interval={100}
              data-sr-duration={1000}
              data-sr-distance={10}
            >
              <span className="flq-subtitle badge" data-sr-item="contact-text">
                Account Deletion Request Form
              </span>
              <h2 className="display-6" data-sr-item="contact-text">
                Fill in your details
              </h2>
            </div>
            <form onSubmit={sendMessage}>
              <div
                className="row gy-4"
                data-sr="contact-form"
                data-sr-interval={100}
                data-sr-duration={1000}
                data-sr-distance={10}
              >
                <div className="col-12 col-sm" data-sr-item="contact-form">
                  <input
                    className="form-control flq-form-user form-control-lg"
                    name="name"
                    type="text"
                    placeholder="Your Name"
                    required
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value);
                    }}
                  />
                </div>
                <div className="col-12 col-sm" data-sr-item="contact-form">
                  <input
                    className="form-control flq-form-mail form-control-lg"
                    name="email"
                    type="email"
                    placeholder="Your Email"
                    required
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                  />
                </div>
                <div className="col-12" data-sr-item="contact-form">
                  <input
                    className="form-control flq-form-message form-control-lg"
                    type="text"
                    placeholder="Subject"
                    value={subject}
                    onChange={(e) => {
                      setSubject(e.target.value);
                    }}
                  />
                </div>
                <div className="col-12" data-sr-item="contact-form">
                  <textarea
                    className="form-control flq-form-message form-control-lg"
                    rows={5}
                    placeholder="Your Message"
                    required
                    value={message}
                    onChange={(e) => {
                      setMessage(e.target.value);
                    }}
                  />
                </div>

                <div className="col-12" data-sr-item="contact-form">
                  {loading ? (
                    <button className="btn btn-lg btn-block" disabled>
                      Submit
                    </button>
                  ) : (
                    <button className="btn btn-lg btn-block">Submit</button>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>

        <Footer />
      </div>
      <NavbarIcons />
      <NavbarMobile page="Account Deletion" />
      <NavbarUser page="Account Deletion" />
    </div>
  );
};

export default AccountDeletion;
